import { APICore } from './apiCore';

const api = new APICore();

function createSubscription(params: { plan_id: number; billing_period: string }) {
    const baseUrl = '/create-subscription';
    return api.create(`${baseUrl}`, params);
}

export { createSubscription };
